export const theme = {
    color: {
        prussianBlue: "#003051CC",
        camarone: "#045B00CC",
        rosewood: "#7A000Ca6",
        brightTeal: "#009191",
        darkTeal: "#006f6f",
    },

    breakpoint: {
        mobileMax: 460,
    },
};
